import React from 'react';
import './ContentPlugins.css';

export default function ContentTypeModal({ open, onClose, onChooseCustom, onChooseLibrary, onChoosePlugin }) {
  if (!open) return null;

  return (
    <div className="contentPluginOverlay" onClick={onClose} role="presentation">
      <div className="contentPluginModal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <h2 className="contentPluginTitle">Add Content</h2>
        <p className="contentPluginSubtitle">Choose how you want to fill this slot</p>
        <div className="contentPluginChoices">
          <button type="button" className="contentPluginChoice" onClick={onChooseCustom}>
            <span className="contentPluginChoiceIcon">🖼️</span>
            <span className="contentPluginChoiceLabel">Custom Slide</span>
            <span className="contentPluginChoiceDesc">Upload your own image or video</span>
          </button>
          <button type="button" className="contentPluginChoice" onClick={onChooseLibrary}>
            <span className="contentPluginChoiceIcon">📚</span>
            <span className="contentPluginChoiceLabel">From Library</span>
            <span className="contentPluginChoiceDesc">Use content you have already created</span>
          </button>
          <button type="button" className="contentPluginChoice" onClick={onChoosePlugin}>
            <span className="contentPluginChoiceIcon">⚡</span>
            <span className="contentPluginChoiceLabel">Plugin</span>
            <span className="contentPluginChoiceDesc">Live weather or sports scores</span>
          </button>
        </div>
        <button type="button" className="contentPluginCancel" onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
}
